<template>
    <div class="avatar">
        <div
            ref="nameRef"
            class="cc-header-right-avatar"
        >
            {{ avatarName }}
        </div>
        <veui-popover
            position="bottom-end"
            :hide-delay="100"
            theme="ai"
            target="nameRef"
            overlay-class="login-overlay"
        >
            <div class="login-overlay-userinfo">
                <div class="login-overlay-avatar">
                    {{ avatarName }}
                </div>
                <div class="login-overlay-username">
                    {{ optName }}
                </div>
            </div>
            <div
                v-for="item in loginOverlayList"
                :key="item.value"
                class="login-overlay-btn"
                @click="redirectUrl(item.value)"
            >
                <template>
                    <component :is="item.icon"/>
                    {{ item.name }}
                </template>
            </div>
            <div class="overlay-line"></div>
            <div class="login-overlay-btn sign-out" @click="handleLogOut">
                <veui-icon name="sign-out"/>
                退出登录
            </div>
        </veui-popover>
    </div>
</template>

<script>
import {Popover, Icon} from 'veui';
import {logoutUcAndPass} from '@/common/util';
import {IconCoinDiamond, IconOrder, IconInfoCircle} from 'dls-icons-vue';
import 'veui-theme-dls-icons/question-circle';
export default {
    name: 'Avatar',
    inject: ['alsLog'],
    // 在这里添加你的数据、计算属性、方法等
    components: {
        'veui-popover': Popover,
        'veui-icon': Icon,
        IconCoinDiamond,
        IconOrder,
        IconInfoCircle
    },
    data() {
        return {
            // 初始数据
        };
    },
    computed: {
        optName() {
            return this.$store.state.app.userInfo.accountInfo?.optName || '';
        },
        avatarName() {
            return this.optName?.slice(0, 1)?.toUpperCase() || '';
        },
        loginOverlayList() {
            const list = [
                {
                    name: '权益中心',
                    value: 'rightsCenter',
                    icon: 'IconCoinDiamond'
                },
                {
                    name: '我的订单',
                    value: 'orderManage',
                    icon: 'IconOrder'
                },
                {
                    name: '关于平台',
                    value: 'aboutUs',
                    icon: 'IconInfoCircle'
                }
            ];
            return list;
        }
    },
    methods: {
        handleLogOut() {
            let pathname = '/index';
            logoutUcAndPass(pathname);
        },
        redirectUrl(value) {
            this.$router.push({
                name: value
            });
        }
    }
};
</script>

<style scoped lang="less">
.avatar {
    .cc-header-right {
        &-avatar {
            cursor: pointer;
            display: flex;
            width: 32px;
            height: 32px;
            padding: 2px 9px 2px 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            border: 1px solid var(--22-g-2, #EBEDF5);
            background: var(--g-0, #FFF);
            color: var(--aia-7, #3A5BFD);
            font-size: 20px;
            font-weight: 500;
        }
    }
}
.login-overlay {
    /deep/ .veui-ai-tooltip {
        border-radius: 12px;
        .veui-ai-tooltip-arrow {
            display: none;
        }
    }
    /deep/ .veui-ai-tooltip-content {
        margin: 16px 8px 8px;
        color: @dls-color-gray-9;
        width: 232px;
    }
    &-userinfo {
        display: flex;
        align-items: center;
        gap: 12px;
        border-bottom: 1px solid var(--22-g-2, #EBEDF5);
        margin-bottom: 16px;
        padding: 0 8px 16px;
    }
    &-avatar {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid var(--22-g-2, #EBEDF5);
        background: var(--g-0, #FFF);
        color: var(--aia-7, #3A5BFD);
        font-size: 20px;
        font-weight: 500;
    }
    &-username {
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
    }
    &-btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        line-height: 36px;
        gap: 8px;
        padding: 0 8px;
        &:last-child {
            margin-top: 8px;
        }
        &:hover {
            border-radius: 4px;
            background: var(--11-g-1, #F6F7FA);
        }
    }
    .overlay-line {
        height: 1px;
        background: #EBEDF5;
        margin: 8px 0;
    }
}
</style>